export default __webpack_public_path__ + "static/media/hero.84e92871.png";